const Main = {
    "es": {
        "title1": "Sobre Mi",
        "contenido1": "Soy desarrollador full stack proactivo, siempre dispuesto a incorporar nuevas habilidades y aceptar desafíos."+
        "  Cuento con un vasto conocimiento integral en diversas tecnologías y plataformas digitales. Me desarrollo de manera eficiente tanto de manera individual como grupal.",
        "title2": "Mis Objetivos",
        "contenido2": "Tengo como objetivo desarrollarme en todo tipo de area tecnologica, se que en cualquier proyecto puedo destacar y autosuperarme. El constante aprendizaje es mi mayor herramienta, en la actualidad me encuentro en el desarrollo de muchos proyectos y en la constante evolucion de mis habilidades tecnicas.",
        "hero":"Hola, mi nombre es:"
    },
    "en": {
        "title1": "About Me",
        "contenido1": "I am a proactive full stack developer, always willing to incorporate new skills and accept challenges. I have a vast comprehensive knowledge in various technologies and digital platforms. I develop efficiently both individually and in groups.",
        "title2": "My Goals",
        "contenido2": "My goal is to develop myself in all kinds of technological areas, I know that in any project I can stand out and improve myself. Constant learning is my greatest tool, currently I am in the development of many projects and in the constant evolution of my technical skills.",
        "hero":"Hi, my name is:"
    },
}
export default Main

